import { PlusOutlined } from '@ant-design/icons';
import { useFieldArrayOf } from '@framework/form/form/relations/useFieldsArrayOf.ts';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Button, Typography } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import { useTreeReferencesContext } from '../../../../../tree/references/TreeReferencesContext.tsx';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { AssignableExpressionInput } from '../../../../expressions/repository/assignable/input/AssignableExpressionInput.tsx';
import { type IComputedDateExpressionOffset } from '../../../../expressions/repository/computed-date/IComputedDateExpression.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { LayoutHideConfigInput } from '../../common/config/LayoutHideConfigInput.tsx';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ComputedWidget } from '../IComputedWidget.ts';
import { ComputedDateOffsetInput } from './ComputedDateOffsetInput.tsx';

const InputBorder = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: 6px;
  padding: 8px;
`;

type IComputedDateConfigComponentProps = IWidgetComponentProps<ComputedWidget>;

export function ComputedDateConfigComponent(
  props: IComputedDateConfigComponentProps,
) {
  const options = getWidgetProps(props);
  const { references } = useTreeReferencesContext();

  // Rimuoviamo la reference al widget stesso
  const filteredReferences = useMemo(
    () => references.filter(r => r.id !== props.widget?.id),
    [references, props.widget?.id],
  );

  const expressionFromField = useMemo(
    () => ({ type: Datatype.Date as const }),
    [],
  );

  const {
    fields: offsets,
    append,
    remove,
  } = useFieldArrayOf<IComputedDateExpressionOffset>({
    name: 'expression.offsets',
  });

  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      {/*  Espressione */}
      {/* Data principale */}
      <InputBorder>
        <FormItem name="expression.from" label="Data di riferimento">
          <AssignableExpressionInput
            field={expressionFromField}
            references={filteredReferences}
            name={'expression.from'}
            block
            size="large"
          />
        </FormItem>

        {offsets.length <= 0 && (
          <Typography.Paragraph type="secondary">
            Imposta un nuovo offset per modificare la data
          </Typography.Paragraph>
        )}

        <ComputedDateOffsetInput
          references={filteredReferences}
          offsets={offsets}
          remove={remove}
        />
        <Button
          icon={<PlusOutlined />}
          type="dashed"
          onClick={() =>
            append({
              amount: null,
              unit: null,
            } as any)
          }
          style={{ width: '100%', marginTop: '12px' }}
        >
          Aggiungi offset
        </Button>
      </InputBorder>

      <LayoutHideConfigInput />
    </div>
  );
}
